import React from 'react'
import { useTranslation } from 'react-i18next';
import { NoContentView } from '../NoContentView/NoContentView';
import { groupRisksByCategory } from '../../utils/Helpers/MapperHelper';

export const RisksDescription = ({ risks }) => {
  const { t } = useTranslation();

  const riskGroup = groupRisksByCategory(risks);

  return (
    <>
      {
        riskGroup.length ? riskGroup?.map((group, index) => {
          return (
            <div data-testid="risk-group" className='risks-group' key={index}>
              <h3 className="chart-title">{t(group.nameRiskType)}</h3>
              {
                group.risks?.map((risk, riskIndex) => {
                  return (
                    <div key={index + '-' + riskIndex} className='risks-content'>
                      <span
                        className="bullet"
                        style={{ backgroundColor: risk.colorSeverity }}
                      ></span>
                      <span>{risk.descriptionRiskProgram}</span>
                    </div>
                  )
                })
              }
            </div>
          )
        })
          : <NoContentView title={t('last_no_information')} description={t('no_risks_info')} />
      }
    </>
  )
}
